import { ArpMedia } from '@arpeggi/shared'
import { Box, Spinner, styled } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { FC, ReactNode } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useArpTableContext } from '.'
import useSelectedMedia from '../../../__legacy__/components/platform/new-explore/hooks/useSelectedMedia'
import { EmptyState } from '../../empty-state'

const Root = styled(InfiniteScroll, {})

const Loader = () => (
  <Box row alignCenter justifyCenter css={{ padding: '24px' }}>
    <Spinner css={{ width: '24px', height: '24px', strokeWidth: '1.5px' }} />
  </Box>
)

type ArpMediaConsumerFunction = (media: ArpMedia) => ReactNode
type TableProps = { children: ArpMediaConsumerFunction; emptyState?: ReactNode }

const DEFAULT_EMPTY_STATE = (
  <EmptyState.Root>
    <EmptyState.Icon />
    <EmptyState.Text>Nothing to show</EmptyState.Text>
  </EmptyState.Root>
)

export const Table: FC<TableProps> = observer(({ children, emptyState = DEFAULT_EMPTY_STATE }) => {
  const { hasMore, nextPage, status, data } = useArpTableContext()
  const { handleSelect } = useSelectedMedia({ queueData: data.map((media) => media.id) })
  const handleClick = (id: number) => () => handleSelect({ id })
  return (
    <>
      <Root hasMore={hasMore} next={nextPage} dataLength={data.length} loader={<Loader />}>
        {status === 'ready' &&
          data.map((media) => (
            <Box key={media.id} onClick={handleClick(media.id)}>
              {children(media)}
            </Box>
          ))}
      </Root>
      {data.length === 0 && status === 'loading' && <Loader />}
      {data.length === 0 && status === 'ready' && emptyState}
    </>
  )
})
